import {
  AIMessage,
  ClarifyOptionsMessage,
  MainActionsMessage,
  PaywallMessage,
  TranslateActionsMessage,
  UpgradeActionsMessage,
  UserMessage,
} from '@components/ArtBoard/AIChat/components/AIChatSidebar/components'
import type React from 'react'

interface ChatMessageItemProps {
  message: any
  index: number
  isLast: boolean
}

export const ChatMessageItem: React.FC<ChatMessageItemProps> = ({
  message,
  index,
  isLast,
}) => {
  switch (message.type) {
    case 'user':
      return (
        <UserMessage key={index} isDescription={message.isDescription}>
          {message.text}
        </UserMessage>
      )

    case 'assistant':
      return (
        <AIMessage key={index} isGenerating={false}>
          {message.text}
        </AIMessage>
      )

    case 'clarify':
      return (
        <ClarifyOptionsMessage
          key={index}
          message={message}
          showOptions={isLast}
        />
      )

    case 'paywall':
      return <PaywallMessage key={index} message={message} />

    case 'actions':
      if (isLast && message.buttons === 'main') {
        return <MainActionsMessage key={index} />
      }

      if (isLast && message.buttons === 'translate') {
        return <TranslateActionsMessage key={index} />
      }

      if (isLast && message.buttons === 'upgrade') {
        return <UpgradeActionsMessage key={index} />
      }

      return null

    default:
      return null
  }
}
